module.exports = __webpack_public_path__ + "static/img/biao1.650b9a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/biao1.png
// module id = OV13
// module chunks = 0